export enum VehicleHistoricType {
  Value = 1,
  Model = 2,
  Version = 3,
  Brand = 4,
  Create = 5,
  Delete = 6,
  Update = 7,
}

export const VEHICLE_HISTORIC_TYPE_LABELS: Readonly<Record<VehicleHistoricType, string>> = {
  [VehicleHistoricType.Value]: 'VEHICLE_HISTORIC.TYPES.VALUE',
  [VehicleHistoricType.Model]: 'VEHICLE_HISTORIC.TYPES.MODEL',
  [VehicleHistoricType.Version]: 'VEHICLE_HISTORIC.TYPES.VERSION',
  [VehicleHistoricType.Brand]: 'VEHICLE_HISTORIC.TYPES.BRAND',
  [VehicleHistoricType.Create]: 'VEHICLE_HISTORIC.TYPES.CREATE',
  [VehicleHistoricType.Delete]: 'VEHICLE_HISTORIC.TYPES.DELETE',
  [VehicleHistoricType.Update]: 'VEHICLE_HISTORIC.TYPES.UPDATE',
};
